import { render } from "./MonthPurchases.vue?vue&type=template&id=609116ca&scoped=true"
import script from "./MonthPurchases.vue?vue&type=script&lang=js"
export * from "./MonthPurchases.vue?vue&type=script&lang=js"

import "./MonthPurchases.vue?vue&type=style&index=0&id=609116ca&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609116ca"]])

export default __exports__